import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import { isHtml } from "../utils/utils";

const TextComponent = ({ text = "", limit = 40 }) => {
  return <>{!isHtml(text) ? <p>{parse(text ?? "")}</p> : parse(text)}</>;
};

export default TextComponent;
